export default "__VITE_ASSET__DZ0GEikX__"